<template>
  <div class="verify-code-input">
    <el-input
      v-model="verifyCode"
      ref="verifyCode"
      class="verify-code"
      maxlength="6"
      :placeholder="this.placeholder || $t('login.common.label.verifyCode')"
      @focus="handleFocus"
      @blur="handleBlur"
    >
      <template #append>
        <span v-if="verifyCodeCountdown > -1" class="send-verify-code has-sent">{{ $t('login.common.label.resendVerifyCode', { countdown: verifyCodeCountdown }) }}</span>
        <span v-else class="send-verify-code" @click="onSendVerifyCodeClick">{{ $t(`login.common.btn.${hasSentVerifyCode ? 'resendVerifyCode' : 'getVerifyCode'}`) }}</span>
      </template>
    </el-input>
    <CaptchaDialog
      class="captcha-dialog"
      :style="customStyle"
      :appendToBody="appendToBody"
      :show.sync="showCaptchaDialog"
      :captchaIndex="captchaIndex"
      @validateCaptcha="handleCaptchaValidate"
    />
  </div>
</template>

<script>
import CaptchaDialog from '@/components/dialog/captchaDialog.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    CaptchaDialog
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    phone: {
      default: null
    },
    placeholder: {
      type: String
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    captchaIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      verifyCodeCountdown: -1,
      hasSentVerifyCode: false,
      showCaptchaDialog: false,
      customStyle: null
    }
  },
  computed: {
    verifyCode: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  },
  created () {},
  mounted () {
    this.customStyle = {
      '--custom-color': getComputedStyle(this.$refs.verifyCode.$el).getPropertyValue('--custom-color')
    }
  },
  methods: {
    ...mapActions('account', ['sendSmsValidateCode']),
    async handleCaptchaValidate (captcha, callback) {
      let errorMessage = null
      try {
        const resp = await this.sendSmsValidateCode({ mobile: this.phone, captcha_index: this.captchaIndex, captcha: captcha })
        if (resp) {
          this.showCaptchaDialog = false
          this.hasSentVerifyCode = true
          this.verifyCodeCountdown = 60
          const id = setInterval(() => {
            this.verifyCodeCountdown -= 1
            if (this.verifyCodeCountdown < 0) {
              clearInterval(id)
            }
          }, 1000)
          this.$refs.verifyCode.focus()
          this.$emit('sendVerifySuccess')
        }
      } catch (err) {
        if (err.code === 20006013) {
          errorMessage = this.$t('login.company.findPassword.email.message.captchaInvalidOrExpired')
        }
      } finally {
        callback(errorMessage)
      }
    },
    onSendVerifyCodeClick () {
      if (this.verifyCodeCountdown > -1 || !this.phone) {
        return
      }
      this.showCaptchaDialog = true
    },
    resetVerifyCode () {
      this.hasSentVerifyCode = false
      this.verifyCodeCountdown = -1
    },
    handleFocus (e) {
      this.$emit('focus', e)
    },
    handleBlur (e) {
      this.$emit('blur', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-code-input {
  .verify-code {
    ::v-deep {
      .el-input__inner {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        &:hover + .el-input-group__append {
          border-color: #c0c4cc;
        }

        &:focus + .el-input-group__append {
          border-color: #0096cc;
        }
      }

      .el-input-group__append {
        padding-left: 0;
        padding-right: 14px;
      }
    }

    .send-verify-code {
      color: #0096cc;
      cursor: pointer;

      &.has-sent {
        cursor: default;
      }
    }
  }
}
</style>
